import { crossJoinNudgeVisitedCache } from '../caching/index.tsx';

const MSR_COUNT_CACHE_KEY = 'CROSS_JOIN_NUDGE_MSR_VISITED_COUNT';

export const getMsrFeatureVisitedCount = (): number => {
	const val = Number(crossJoinNudgeVisitedCache.get(MSR_COUNT_CACHE_KEY));
	if (Number.isNaN(val)) return 0;
	return val;
};

export const incrementMsrFeatureVisitedCount = (): number => {
	const currentCount = getMsrFeatureVisitedCount();
	const newCount = currentCount + 1;
	crossJoinNudgeVisitedCache.set(MSR_COUNT_CACHE_KEY, newCount);
	return newCount;
};
